// 引用axios
import {Loading, Message} from 'element-ui' // 引入elm组件
//   import store from '../store/index' // 通过vuex 来存储 token等信息
import axios from 'axios'
import router from '../../router'
const CryptoJS = require('crypto-js')
let loadingInstance
let pending = []
// 声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let CancelToken = axios.CancelToken
let removePending = (config) => {
  for (let p in pending) {
    if (pending[p].u === config.url + '&' + config.method) {
      // 当前请求在数组中存在时执行函数体
      pending[p].f()
      // 执行取消操作
      pending.splice(p, 1)
      // 把这条记录从数组中移除
    }
  }
}
// ajax请求统一增加请求头
axios.interceptors.request.use(config => {
  const _time = new Date().getTime()
  const _key = CryptoJS.enc.Utf8.parse(_time + 1000000000000000)
  let encryptedData = CryptoJS.AES.encrypt(localStorage.token === undefined ? '' : localStorage.token, _key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  encryptedData = encryptedData.ciphertext.toString()
  const encryptedHexStr = CryptoJS.enc.Hex.parse(encryptedData)
  const encryptedBase64Str = CryptoJS.enc.Base64.stringify(encryptedHexStr)
  if (config.url !== '/api-v1/as/login-keys') {
    config.headers.common = {
      'time': _time,
      'token': encryptedBase64Str
    }
  }
  // if (config.url !== '/api-v1/as/login-keys') {
  //   config.headers.common = {
  //     'token': localStorage.token === undefined ? '' : localStorage.token
  //   }
  // }
  config.timeout = 60000
  let strData = JSON.stringify(config.data || '{}')
  // 参数中携带cancelHttp，不防止多次请求
  if (strData.indexOf('cancelHttp') > -1) {
    httpFlag = false
  } else {
    removePending(config)
    // 在一个ajax发送前执行一下取消操作
    config.cancelToken = new CancelToken((c) => {
      // 这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
      pending.push({ u: config.url + '&' + config.method, f: c })
    })
  }
  // 这行代码开始加载中组件，而且是全屏展示
  loadingInstance = Loading.service({ fullscreen: true })
  return config
},
err => {
  return err
})

// 是否防止多次请求
let httpFlag = true
// 拦截响应response，并做一些错误处理
axios.interceptors.response.use((response) => {
  if (httpFlag) {
    removePending(response.config)
    // 在一个ajax响应后再执行一下取消操作，把已经完成的请求从pending中移除
  }
  if (loadingInstance) {
    loadingInstance.close()
  }
  return response
}, (err) => {
  loadingInstance.close()
  // 这里是返回状态码不为200时候的错误处理
  if (err.toString().indexOf('timeout') !== -1) {
    console.log(this)
    Message({
      message: '请求超时，请稍后再试',
      type: 'error'
    })
  }
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        err.message = '请求错误'
        break

      case 401:
        localStorage.token = ''
        err.message = '请登录'
        router.push({
          name: 'login'
        })

        break

      case 403:
        err.message = '拒绝访问'
        break

      case 404:
        err.message = `请求地址出错: ${err.response.config.url}`
        break
      case 405:
        err.message = `请求地址出错:`
        break
      case 408:
        err.message = '请求超时'
        break

      case 500:
        // if (err.response.data.message.indexOf(''))
        err.message = '网络错误，请稍后再试'
        break

      case 501:
        err.message = '网络错误，请稍后再试'
        break

      case 502:
        err.message = '网络错误，请稍后再试'
        break

      case 503:
        err.message = '网络错误，请稍后再试'
        break

      case 504:
        err.message = '网络错误，请稍后再试'
        break

      case 505:
        err.message = 'HTTP版本不受支持'
        break

      default:
    }
    if (err.response.data.msg) {
      err.message = err.response.data.msg
    }
    Message({
      message: err.message,
      type: 'error'
    })
  }
  return Promise.reject(err)
})
export default axios



// WEBPACK FOOTER //
// ./src/js/common/axios.js